

// Libs
import { ref } from 'vue';

import router from "@/router";

// Components
import PsLabel from '@/components/core/label/PsLabel.vue';
import PsLabelCaption from '@/components/core/label/PsLabelCaption.vue';
import PsInputWithLeftIcon from '@/components/core/input/PsInputWithLeftIcon.vue';
import PsIcon from '@/components/core/icons/PsIcon.vue';
import PsDropdown from '@/components/core/dropdown/PsDropdown.vue';
import PsLoadingDialog from '@/components/core/dialog/PsLoadingDialog.vue';

// Providers
import { useItemLocationProviderState } from '@/store/modules/itemlocation/ItemLocationProvider';
import { createItemLocationTownshipProviderState } from '@/store/modules/itemLocationTownship/ItemLocationTownshipProvider';
import { useProductProviderState } from '@/store/modules/item/ProductProvider';
import { PsValueProvider } from "@/store/modules/core/PsValueProvider";
import AppInfoParameterHolder from '@/object/holder/AppInfoParameterHolder';
import { usePsAppInfoProviderState } from '@/store/modules/appinfo/AppInfoProvider';

import LocationParameterHolder from '@/object/holder/LocationParameterHolder';


export default {
    name: "SearchForLargeScreenView",
    components: {
        PsLabel,
        PsLabelCaption,
        PsInputWithLeftIcon,
        PsIcon,
        PsDropdown,
        PsLoadingDialog,
    },
    props: {
        data: {
            type: String,
            default: '0'
        },
    },
    emits: ['clicklocation', 'onSubclick'],
    setup(props, context) {
        function isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
        // Inject Provider
        const locationKeyword = ref('');

        const psValueHolder = PsValueProvider.psValueHolder;
        const ps_loading_dialog = ref();

        psValueHolder.updateExpiryTimeForAction(); // only call from dashboard
        const appInfoProvider = usePsAppInfoProviderState();
        const searchKeyword = ref("");
        const locationName = ref(psValueHolder.locationName ?? 'All');
        const locationId = ref(psValueHolder.locationId);
        const sublocationId = ref(psValueHolder.locationId);
        const sublocationName = ref(psValueHolder.subLocationName ?? 'All');

        const itemlocationProvider = useItemLocationProviderState();
        const subLocationProvider = createItemLocationTownshipProviderState();

        const itemProvider = useProductProviderState();


        const loginUserId = psValueHolder.getLoginUserId();

        const paramHolder = new LocationParameterHolder().getDefaultParameterHolder();


        async function searchClicked() {

            itemProvider.paramHolder.searchTerm = searchKeyword.value;
            itemProvider.paramHolder.itemLocationName = locationName.value.toString();

            searchKeyword.value = '';

            const params = itemProvider.paramHolder.getUrlParamsAndQuery();
            params['name'] = 'item-list';
            router.push(params);

        }

        function loadLocationList() {

            itemlocationProvider.loadItemLocationList(psValueHolder.getLoginUserId(), paramHolder);
        }

        function loadSubLocation(itemLocationId) {
            subLocationProvider.loadItemLocationTownshipList(itemLocationId);
        }

        async function locationFilterClicked(id, name, lat, lng) {

            locationId.value = id;
            locationName.value = name;

            psValueHolder.replaceLocation(id, name, lat, lng);
            psValueHolder.replaceSubLocation('', 'All');

            sublocationId.value = '';
            sublocationName.value = 'All';
            itemProvider.paramHolder.itemLocationTownship = '';
            itemProvider.paramHolder.itemLocationTownshipName = 'All';
            ps_loading_dialog.value.openModal();
            await itemProvider.updateLocation(loginUserId, locationId.value, locationName.value);
            ps_loading_dialog.value.closeModal();
            subLocationProvider.resetItemLocationTownshipList(id);
            context.emit('clicklocation', { id: id, name: name, lat: lat, lng: lng });

        }

        async function subLocationFilterClicked(id, townshipName) {
            sublocationId.value = id;
            sublocationName.value = townshipName;
            psValueHolder.replaceSubLocation(id, townshipName);
            itemProvider.paramHolder.itemLocationTownship = id;
            itemProvider.paramHolder.itemLocationTownshipName = townshipName;
            context.emit('onSubclick', { id: locationId.value, name: locationName.value, subId: id, subName: townshipName });

        }

        function filterKeywordUpate(value) {
            itemlocationProvider.filterKeywordUpate(value, loginUserId, paramHolder);
        }

        const appInfoParameterHolder = new AppInfoParameterHolder();
        appInfoParameterHolder.userId = loginUserId;
        appInfoProvider.loadDeleteHistory(appInfoParameterHolder);

        return {
            PsValueProvider,
            itemlocationProvider,
            subLocationProvider,
            itemProvider, isMobile,
            searchKeyword,
            searchClicked,
            locationName,
            locationId,
            sublocationId,
            sublocationName,
            loadLocationList,
            locationFilterClicked,
            locationKeyword,
            ps_loading_dialog,
            filterKeywordUpate,
            subLocationFilterClicked,
            loadSubLocation,
            appInfoProvider
        };
    },
};
